import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { router } from './router'
import { useAuthStore } from './store/authStore'
import './styles/globals.css'

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''

function AuthRehydrator() {
  const rehydrate = useAuthStore((s) => s.rehydrate)
  useEffect(() => { rehydrate() }, [rehydrate])
  return null
}

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <HelmetProvider>
        <AuthRehydrator />
        <RouterProvider router={router} />
      </HelmetProvider>
    </GoogleOAuthProvider>
  )
}

export default App
